<div *ngIf="!isMobile; else mobileDateRange" class="calendar-container bg-fff">
  <div class="calendars-body flex justify-content-between">
    <div class="calendar">
      <div class="calendar-header flex_sb fs-16 fw-600 lh-130 clr-333 m-b-8">
        <button (click)="previousMonth()" class="m-r-40">
          <img [src]="images?.BACK" alt="previous" />
        </button>
        <span>{{ monthStart | date : 'MMMM yyyy' }}</span>

        <button (click)="nextMonth()" class="m-l-40">
          <img class="next-icon" [src]="images?.BACK" alt="next" />
        </button>
      </div>
      <div class="calendar-grid">
        <div
          *ngFor="let day of daysOfWeek; trackBy: trackByDay"
          class="day-name fs-12 lh-130 fw-400 clr-999 ta_center"
        >
          {{ 'DATE_RANGE.' + day | translate }}
        </div>
        <div class="divider m-b-10 m-t-10"></div>
        <div
          *ngFor="let day of monthDays; trackBy: trackByDay"
          (click)="selectDate(day?.date)"
          class="box flex-center flex_column ta_center clr-333 fs-12 fw-400 lh-130 c-pointer"
          [ngClass]="{
                'opacity-half': day?.isDisabled,
                selected: day?.isSelected,
              }"
        >
          <div>{{ day?.date ? day.date?.getDate() : '' }}</div>
          <div class="today ta_center" *ngIf="day?.isToday"></div>
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="timeInput"></ng-container>
  </div>

  <!-- Footer for date display and actions -->
  <div class="calendars-footer flex_sb">
    <div class="footer-dates flex_sb fb-50">
      <div class="start-date date-time-bg">
        <div class="footer-date-label fs-12 fw-400 lh-130 clr-666">Date</div>
        <div class="footer-date-value fs-14 fw-600 lh-140 clr-666">
          <ng-container *ngIf="selectedDate; else noStartDate">
            {{ selectedDate | date : 'dd-MM-yyyy' }}
          </ng-container>
          <ng-template #noStartDate> - </ng-template>
        </div>
      </div>

      <div class="selected-time date-time-bg">
        <div class="footer-date-label fs-12 fw-400 lh-130 clr-666">Time</div>
        <div class="footer-date-value fs-14 fw-600 lh-140 clr-666">
          {{ selectedTime?.hour || '00' }} :
          {{ selectedTime?.minute || '00' }}
          {{ selectedTime?.period }}
        </div>
      </div>
    </div>
    <div class="footer-actions flex_sb">
      <button
        (click)="cancelSelection()"
        class="cancel-btn fs-14 lh-140 fw-600 clr-999"
      >
        {{ 'DATE_RANGE.CANCEL' | translate }}
      </button>
      <button
        class="apply-btn fs-14 fw-400 lh-130 color-white m-l-20"
        [disabled]="!selectedDate || !selectedTime || hasTimeInputError"
        (click)="applySelection()"
      >
        {{ 'DATE_RANGE.APPLY' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- For mobile -->

<ng-template #mobileDateRange>
  <div class="mpos-date-range bg-fff">
    <div class="input-type fs-16 clr-333 fw-600">
      {{ !showTimeInput ? 'Choose a Date' : 'Set Time' }}
    </div>

    <div *ngIf="!showTimeInput; else timeInput" class="">
      <div
        class="mpos-calendar-header flex_sb ta_center p-t-12 p-b-12 p-l-16 p-r-16"
      >
        <button (click)="previousMonth()" class="m-r-40">
          <img [src]="images?.BACK" alt="previous" />
        </button>
        <span class="fs-14 fw-600 lh-130 clr-666">{{
          monthStart | date : 'MMMM yyyy'
        }}</span>
        <button (click)="nextMonth()" class="m-l-40">
          <img class="next-icon" [src]="images?.BACK" alt="next" />
        </button>
      </div>
      <div class="calendar-grid p-l-4 p-r-4">
        <div
          *ngFor="let day of daysOfWeek; trackBy: trackByDay"
          class="day-name fs-12 lh-130 fw-600 clr-999 ta_center p-t-12 p-b-12"
        >
          {{ 'DATE_RANGE.' + day | translate }}
        </div>
        <div class="divider m-b-4"></div>
        <div
          *ngFor="let day of monthDays; trackBy: trackByDay"
          (click)="selectDate(day?.date)"
          class="box flex-center flex_column ta_center clr-333 fs-14 fw-400 lh-130 c-pointer"
          [ngClass]="{
              'opacity-half': day?.isDisabled,
              selected: day?.isSelected,
            }"
        >
          <div>{{ day?.date ? day.date?.getDate() : '' }}</div>
          <div class="today ta_center" *ngIf="day?.isToday"></div>
        </div>
      </div>
    </div>
    <div class="mpos-date-range-footer bg-fff">
      <div class="flex_sb">
        <div
          class="start-date mpos-footer-date flex-1"
          [ngClass]="{
            'selected-mpos-date': !showTimeInput
          }"
          (click)="toggleDateTime()"
        >
          <div class="clr-666 fs-12 lh-130 fw-400">Date</div>
          <div class="clr-333 fs-14 lh-130 fw-600">
            <ng-container *ngIf="selectedDate; else noStartDate">
              {{ selectedDate | date : 'dd-MM-yyyy' }}
            </ng-container>
            <ng-template #noStartDate> - </ng-template>
          </div>
        </div>

        <div
          class="start-date mpos-footer-date flex-1 m-l-16"
          [ngClass]="{
            'selected-mpos-date': showTimeInput
          }"
          (click)="toggleDateTime()"
        >
          <div class="clr-666 fs-12 lh-130 fw-400">Time</div>
          <div class="clr-333 fs-14 lh-130 fw-600">
            {{ selectedTime?.hour || '00' }} :
            {{ selectedTime?.minute || '00' }}
            {{ selectedTime?.period }}
          </div>
        </div>
      </div>
      <div class="flex_sb m-t-14">
        <button
          (click)="cancelSelection()"
          class="mpos-cancel-btn mpos-btn fs-14 lh-140 fw-600 wd-100 m-r-16"
        >
          {{ 'DATE_RANGE.CLOSE' | translate }}
        </button>
        <button
          class="apply-btn mpos-btn wd-100 fs-14 lh-130 fw-400 color-white"
          [disabled]="!selectedDate || !selectedTime || hasTimeInputError"
          (click)="applySelection()"
        >
          {{ 'DATE_RANGE.APPLY' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #timeInput>
  <div class="time-wrapper">
    <div class="fs-16 clr-333 fw-600 m-b-16">Type Time</div>
    <custom-time-picker
      [initialTime]="selectedTime"
      (timeSelected)="onTimeSelected($event)"
      (errorStatus)="onErrorStatus($event)"
    ></custom-time-picker>
  </div>
</ng-template>
